import { render, staticRenderFns } from "./DashboardSMANationalChairman.vue?vue&type=template&id=52fb6fbc"
import script from "./DashboardSMANationalChairman.vue?vue&type=script&lang=js"
export * from "./DashboardSMANationalChairman.vue?vue&type=script&lang=js"
import style0 from "./DashboardSMANationalChairman.vue?vue&type=style&index=0&id=52fb6fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports